// third-party
import { FormattedMessage } from 'react-intl';

// assets
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';

// type

// icons
const icons = { GroupAddOutlinedIcon };

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const users = {
  id: 'users',
  title: <FormattedMessage id="Users" />,
  icon: icons.GroupAddOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'user-list',
      key:'user-list',
      title: <FormattedMessage id="Users" />,
      type: 'item',
      url: '/user-list',
      icon: icons.GroupAddOutlinedIcon
    }
  ]
};

export default users;
